import React, {
    Fragment,
    useEffect,
    useState,
} from "react";
import {historyColumn} from "Constants/TableColumns";
import Translator from "Languages/Utility/Translator";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { read } from "Helpers/LocalStorage";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import PaymentService from "Services/http/endpoints/payment/PaymentService";
import StatusHandler from "Helpers/StatusHandler";

function HistoriesTable() {
    const [loading, setLoading] = useState(false);
    const [sizePerPage, setSizePerPage] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [tblData, setTblData] = useState([]);

    const onTableChange = async (type, { page, sizePerPage }) => {
        if (type === "pagination") {
            const params = {
                keyGroup: read("groupKey"),
                keyUser: read("userKey"),
                Limit: sizePerPage,
                Page: page,
            };
            await GetHistory(params);
            setCurrentPage(page);
            setSizePerPage(sizePerPage);
        }
    };

    const GetHistory = async (params) => {
        try {
            setLoading(true);
            const response = await PaymentService.GetHistory(params);
            const err = StatusHandler(response);
            if (!err.isFail) {
                setTblData(response.data.Value);
                setCurrentPage(response.data.Pagination.Page) ;
                setSizePerPage(response.data.Pagination.Limit) ;
                setTotal(response.data.Pagination.Total) ;
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
        }
    };

    useEffect(() => {
        (async () => {
            const params = {
                keyGroup: read("groupKey"),
                keyUser: read("userKey"),
                Limit: sizePerPage,
                Page: currentPage,
            };
            await GetHistory(params);
        })();
    }, []);

    return (
        <Fragment>
            <BackDropLoading loading={loading} />
            <RemoteTable
                data={tblData}
                columns={historyColumn}
                page={currentPage}
                sizePerPage={sizePerPage}
                totalSize={total}
                onTableChange={onTableChange}
                title={<Translator id="history_list" />}
            />
        </Fragment>
    );
}

export default HistoriesTable;
